export const setLang = (v) => localStorage.setItem('lang', v);
export const currentLang = localStorage.getItem('lang');

export default {
  setLang,
  currentLang,
};
